module.exports = __webpack_public_path__ + "img/bloemkoolcouscous-met-abrikozen-en-kip.e077b3c1.jpeg";